<!-- /**
* 工人详情页-荣誉证书
*/ -->
<template>
  <div>
    <div v-if="data && data.length">
        <div class="experiences" v-for="(item, index) in data" :key="index">
          <div class="item_experience">
            <div class="item_adres">
              <h3>{{ item.name }}</h3>
            </div>
            <el-row :gutter="20" v-if="item.url.length > 0">
              <el-col>
                <div class="item_flex">
                  <div class="flex_title">
                    <span>证书图片：</span>
                  </div>
                  <el-image
                    class="item_pic"
                    v-for="(item, index) in item.url"
                    :key="index"
                    :src="item.fileUrl"
                    :preview-src-list="[item.fileUrl]"
                    fit="cover"
                  ></el-image>
                </div>
              </el-col>
            </el-row>
            <el-row
              v-if="
                item.certificateFieldList && item.certificateFieldList.length
              "
            >
              <el-col
                :span="24"
                class="detail-item"
                v-for="(field, index) in item.certificateFieldList"
                :key="index"
              >
                <span class="item-name">{{ field.name }}：</span>
                <span class="item-value">{{ field.content }}</span>
              </el-col>
            </el-row>
          </div>
        </div>
    </div>
    <BaseEmptyData
      isDetail
      v-if="!(data && data.length) && !loadingTrue"
    ></BaseEmptyData>
  </div>
</template>

<script>
export default {
  name: "honor",
  inject: ["reload"], // 引入App.vue 中的刷新页面的方法
  props: {
    data: {
      type: Array,
      default: []
    }
  },
  data() {
    return {}
  },
  components: {
    BaseEmptyData: () => import("@/components/public/BaseEmptyData") // 暂无数据缺省图
  },
}
</script>

<style lang="scss" rel="stylesheet/scss" scoped>
div {
  box-sizing: border-box;
}
.leftBox {
  width: 100%;
  .workerDetail_tab {
    background-color: #fff;
    .experiences {
      padding: 15px;
      background: #f5f7fa;
      margin-bottom: 10px;
      :nth-child(2n) {
        margin-right: 0;
      }
      .item_experience {
        .item_adres {
          display: flex;
          padding-bottom: 10px;
          .timer {
            font-size: 16px;
            font-weight: bold;
          }
        }
        .detail-item {
          display: flex;
          padding-top: 10px;
          line-height: 22px;
          .item-name {
            flex-wrap: wrap;
            max-width: 162px;
            flex-shrink: 0;
            color: var(--FC6);
          }
          .item-value {
            color: var(--FC3);
            .item-video {
              position: relative;
              display: inline-block;
              width: 150px;
              height: 100px;
              cursor: pointer;
              > video {
                width: 100%;
                height: 100%;
              }
              &:before {
                content: "";
                position: absolute;
                top: 50%;
                left: 50%;
                transform: translate(calc(-50% + 10px), -50%);
                border: solid;
                border-width: 10px 15px;
                border-color: transparent transparent transparent #fff;
              }
            }
          }
        }
      }
      .item_flex {
        display: flex;
        line-height: 22px;
        .flex_title {
          width: 70px;
        }
        .item_tag {
          flex: 1;
        }
        .item_pic {
          margin-right: 10px;
          width: 80px;
          height: 80px;
          img {
            width: 100%;
            height: 100%;
          }
        }
      }
    }
  }
}
</style>
